import axiosInstance from './axiosInstance';

/**
 * Transport adapter for the synchronization endpoints.
 *
 * Keeping Axios response handling here lets the server-to-local sync service consume the
 * protocol document directly without depending on HTTP response wrappers.
 */
export default {
  /**
   * Pulls one authoritative page for the authenticated user.
   *
   * @param {{last_seen_server_version: number, page_size: number}} request
   * @returns {Promise<Object>} Protocol v3 pull response.
   */
  pull: ({ last_seen_server_version, page_size }) =>
    axiosInstance
      .get('/sync/pull', {
        params: { last_seen_server_version, page_size }
      })
      .then((response) => response.data)
};
